import { init } from '@sentry/react'
import config from '../config'

const sentryConfig = () => {
  const dsn = config.SENTRY_DSN
  const environment = config.SENTRY_ENVIRONMENT || 'frontend'
  if (dsn) {
	   init({ dsn, environment })
  }
}

export default sentryConfig
